import { inject, PLATFORM_ID, TransferState } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { TENANT_TRANSFER_STATE_KEY } from '../ssr/tenant-transfer-state';

export const tenantGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const transferState = inject(TransferState);

  const tenantFromTransferState = transferState.get(TENANT_TRANSFER_STATE_KEY, null);

  if (tenantFromTransferState) {
    return true;
  }

  // During SSR the tenant is resolved from the request host and placed in the
  // transfer state (handled by the early return above). If it's absent, we must
  // not let the route render (its data fetches would hang and time out), so
  // redirect to /maintenance instead of ending up with a 404. The maintenance
  // page is client-rendered and retries the hostname lookup in the browser.
  if (!isPlatformBrowser(platformId)) {
    return router.createUrlTree(['/maintenance'], { queryParams: { redirect: state.url } });
  }

  const tenant = localStorage.getItem('tenant.uuid');

  if (tenant) {
    return true;
  }

  // Browser, and the tenant could not be resolved from either source
  // (data_not_found) — only now send the user to maintenance.
  const redirect = encodeURIComponent(state.url);
  router.navigate(['/maintenance'], { queryParams: { redirect } });
  return false;
};
